import { render, staticRenderFns } from "./goods_detail.vue?vue&type=template&id=cb439afa&scoped=true&"
import script from "./goods_detail.vue?vue&type=script&lang=js&"
export * from "./goods_detail.vue?vue&type=script&lang=js&"
import style0 from "./goods_detail.vue?vue&type=style&index=0&id=cb439afa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb439afa",
  null
  
)

export default component.exports